import { motion } from "framer-motion";
import { ShieldAlert, ArrowRight, LogOut } from "lucide-react";

export default function AgeGate({ onAccept }) {
  return (
    <motion.div
      data-testid="age-gate-container"
      className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/92 backdrop-blur-2xl"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: 0.6 } }}
    >
      <motion.div
        className="relative max-w-lg w-full border border-white/10 bg-panel p-10 sm:p-14 text-center overflow-hidden"
        initial={{ scale: 0.92, y: 30, opacity: 0 }}
        animate={{ scale: 1, y: 0, opacity: 1 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
      >
        <div className="scanlines" />
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          <ShieldAlert className="mx-auto mb-6 text-magma" size={40} strokeWidth={1.5} />
        </motion.div>
        <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-cyber mb-4">
          Restricted Access // Adults Only
        </p>
        <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tight leading-none mb-6">
          You must be <span className="text-magma">18+</span> to enter
        </h1>
        <p className="text-sm text-slate-400 leading-relaxed mb-10">
          AETHERIA crafts synthetic adult companions. This site contains
          mature product content intended exclusively for adults of legal age
          in their jurisdiction.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            data-testid="age-gate-accept-btn"
            onClick={onAccept}
            className="group inline-flex items-center justify-center gap-2 bg-magma text-white font-display font-bold uppercase tracking-widest text-sm px-8 py-4 glow-magenta hover:bg-[#ff4d87] transition-colors duration-300"
          >
            I am 18 or older
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
          <a
            data-testid="age-gate-decline-btn"
            href="https://www.google.com"
            className="inline-flex items-center justify-center gap-2 border border-white/15 text-slate-400 font-display font-bold uppercase tracking-widest text-sm px-8 py-4 hover:border-white/40 hover:text-white transition-colors duration-300"
          >
            <LogOut size={16} />
            Leave
          </a>
        </div>
        <p className="mt-8 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-slate-600">
          By entering you agree to our terms & privacy architecture
        </p>
      </motion.div>
    </motion.div>
  );
}
